<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
    >

      <span slot="action" slot-scope="text, record">
        <a-popconfirm placement="topLeft" title="确定要删除此计量单位吗?删除后无法恢复！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
          <a href="#">删除</a>
        </a-popconfirm>
      </span>
    </s-table>
    <a-modal
      :title="title"
      style="top: 20px;"
      :width="800"
      v-model="visible"
      @ok="editFormSubmit($event,selectrow)"
    >
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="名称"
        >
          <a-input
            placeholder="名称"
            v-model="selectrow.name"
            autocomplete="false"
          />
        </a-form-item>

      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getUnitList, editUnit, addUnit, deleteUnit } from '@/api/unit'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'SettingsUnitList',
  components: {
    STable
  },
  data () {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: null,
      isEditForm: false,
      title: '新增',
      selectrow: {},

      // 查询参数
      queryParam: {
      },
      // 表头
      columns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getUnitList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {

  },
  methods: {
    deleteConfirm (id) {
      deleteUnit({ id: id }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          this.reloadTable()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleAdd () {
      this.selectrow = {
        name: ''
      }
      this.title = '新增'
      this.isEditForm = false
      this.visible = true
    },
    // 修改表单提交
    editFormSubmit (e) {
      e.preventDefault()
      const data = this.selectrow
      if (this.isEditForm) {
        editUnit(data).then(res => {
          if (res.status !== CODE_FAIL) {
            this.visible = false
            this.$message.success('修改成功')
            this.reloadTable()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        addUnit(data).then(res => {
          if (res.status !== CODE_FAIL) {
            this.visible = false
            this.$message.success('新增成功')
            this.reloadTable()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    resetTableSearch () {
      this.queryParam = {}
      this.reloadTable()
    }
  },
  watch: {
  }
}
</script>
